export default __webpack_public_path__ + "static/media/leaf2.042d4403.png";